<template>
  <div class="table-detail">
		<table class="w-100 head-table">
			<colgroup class="d-flex">
				<col class="description-col">
				<col class="col-style">
				<col class="col-style">
				<col class="col-style">
			</colgroup>
			<thead>
				<tr>
					<th>Producto</th>
					<th>Precio de Venta</th>
					<th>Cantidad</th>
					<th>Total</th>
					<th v-if="orderState === 'GIVEN'">Acciones</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in rows" :key="index">
					<td class="align-center description-cell txt-left">
						<div class="img-product">
							<img
								:src="item.productImage"
								alt="imagen del producto"
							>
						</div>
						<div>
							<p><i><b>{{item.productName}}</b></i></p>
							<p>{{item.description}}</p>
						</div>
					</td>
					<td>{{item.salePrice}}</td>
					<td>{{item.quantity}}</td>
					<td>{{item.total}}</td>
					<td v-if="orderState === 'GIVEN'">
						<button
							class="btn-table"
							title="Calificar producto"
							@click="$emit('rating', item)">
							<img 
								src="/static/img/icons/comments.svg" 
								alt="Ver detalle"
								class="table-view">
						</button>
					</td>
				</tr>	
			</tbody>	
		</table>	
	</div>  
</template>

<script>
export default {
	name: 'table-detail-product',
	props: {
		orderState: {
			default: '',
			type: String,
		},
		rows: {
			default: () => [],
			type: Array,
		},
	},
};
</script>

<style lang="scss" scoped>

.head-table {

	tbody {
		font-size: size(normal);

		tr {
			border-bottom: 0.1rem solid color(border-grey) !important;
		}
	}
}

.description-cell {
	box-sizing: content-box;
	display: grid;
	grid-column-gap: 1rem;
	grid-template-columns: 0.5fr 2fr;
	height: 6rem;

	p {
		margin: 0;
	}
}
th {
	background-color: color(border-grey);
	font-size: size(small);
	padding: 0.8rem;
}

td {
	padding: 1rem;
	text-align: center;
}

table {
	border: 0.1rem solid color(border-grey);
	border-collapse: collapse;
}

.table-detail {
	border: 0.1rem solid color(border-grey);
}

.img-product {
	height: 4.2rem;
	width: 4.2rem;

	img {
		height: 100%;
		object-fit: cover;
		width: 100%;
	}
}

.description-col {
	flex-basis: 30%;
}

.col-style {
	flex-basis: auto
}

.btn-table {
	border: none;
	background: none;
	outline: none;
}
</style>



// WEBPACK FOOTER //
// table-detail-product.vue?c7e8e9d0